<template>
    <div class="container login-container">        
        <b-modal id="passconfirmmodal" centered no-close-on-backdrop hide-footer title="Confirm your password">
            <b-form @submit.stop.prevent="checkPass">                
                <b-form-group id="password-group" label="Password" label-for="password">
                    <b-form-input id="password" name="password" placeholder="Password" type="password" v-model="passconfirm" v-validate="{ required: true, min: 8 }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                    <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group id="login-submit-group">
                    <b-button type="submit" variant="primary">Submit</b-button>
                </b-form-group>
            </b-form>
        </b-modal>
    </div>        
</template>
 
<script>
    
    export default{
        
        mounted() {
            this.$bvModal.show('passconfirmmodal');
        },
        props: [ 'the_id', 'fun_name'],
        components: {
            
        },
        data(){            
            
            return {                                  
                
                passconfirm : '',
                
            }
        },
        methods:{
            checkPass : function(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();  
                    let currentObj = this;

                    let formData = new FormData();
                    formData.append('password', this.passconfirm);  

                    axios.post(this.$api_url + '/checkpass', formData)
                                .then(function (response) 
                                {
                                    this.passconfirm = '';
                                    if(response.data.status == true)
                                    {   
                                        this.$bvModal.hide('passconfirmmodal');
                                        this.$parent[this.fun_name](this.the_id);  
                                    }
                                    else
                                    {
                                        currentObj.$bvToast.toast('Wrong password.', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });
                                    }                                    
                                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                });
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

        },
        created: function(){
            //this.$bvModal.show('passconfirmmodal');
        }
    }
</script>